/**
 * Events Location Filter
 * Filters event cards by location in the main blog page
 */

class EventsLocationFilter {
  constructor() {
    this.locationFilter = document.getElementById('location-filter');
    this.eventsContainer = document.getElementById('events-container');
    this.articleData = [];
    this.translations = window.eventsFilterTranslations || {};
    
    if (this.locationFilter && this.eventsContainer) {
      this.init();
    }
  }

  init() {
    this.collectArticleData();
    this.bindEvents();
    this.applyFilterFromUrl();
  }

  collectArticleData() {
    const eventCards = this.eventsContainer.querySelectorAll('.event-card');
    
    eventCards.forEach((card, index) => {
      const locationElement = card.querySelector('.event-card__location');
      const location = locationElement ? locationElement.textContent.trim() : '';
      
      this.articleData.push({
        element: card.closest('[data-event-item]') || card,
        location: location,
        originalIndex: index
      });
    });
  }

  bindEvents() {
    this.locationFilter.addEventListener('change', (event) => {
      this.updateLocationQuery(event.target.value);
    });
  }

  updateLocationQuery(selectedLocation) {
    const url = new URL(window.location.href);

    if (selectedLocation === '') {
      url.searchParams.delete('location');
    } else {
      url.searchParams.set('location', selectedLocation);
    }

    url.searchParams.delete('events_page');
    window.location.assign(url.toString());
  }

  filterByLocation(selectedLocation) {
    let visibleCount = 0;

    this.articleData.forEach((data) => {
      const normalizedLocation = data.location.toLowerCase();
      let shouldShow = selectedLocation === '';

      if (selectedLocation === 'hartville') {
        shouldShow = normalizedLocation.includes('hartville');
      } else if (selectedLocation === 'middlefield') {
        shouldShow = normalizedLocation.includes('middlefield');
      }
      
      if (shouldShow) {
        data.element.style.display = '';
        data.element.classList.remove('filtered-out');
        visibleCount++;
      } else {
        data.element.style.display = 'none';
        data.element.classList.add('filtered-out');
      }
    });

    const filterEvent = new CustomEvent('eventsFiltered', {
      detail: {
        selectedLocation: selectedLocation,
        visibleCount: visibleCount,
        totalCount: this.articleData.length
      }
    });
    
    document.dispatchEvent(filterEvent);
  }

  getCurrentFilter() {
    return this.locationFilter ? this.locationFilter.value : '';
  }

  applyFilterFromUrl() {
    const url = new URL(window.location.href);
    const locationParam = (url.searchParams.get('location') || '').toLowerCase();

    if (!this.locationFilter) return;

    if (locationParam === 'hartville' || locationParam === 'middlefield') {
      this.locationFilter.value = locationParam;
      this.filterByLocation(locationParam);
      return;
    }

    this.locationFilter.value = '';
    this.filterByLocation('');
  }

  resetFilter() {
    if (this.locationFilter) {
      this.locationFilter.value = '';
      this.filterByLocation('');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.eventsLocationFilter = new EventsLocationFilter();
});